import { Fragment, useRef, useState } from 'react';
import { type BusinessProduct } from '@recargas-dominicanas/core/types';
import { Cell } from '@recargas-dominicanas/core/components';
import { TableRow } from '@recargas-dominicanas/core/components';
import { CellIcon } from '@recargas-dominicanas/core/components';
import { CellImage } from '@recargas-dominicanas/core/components';
import { Menu } from '@recargas-dominicanas/core/components';
import { formatCurrency } from '@recargas-dominicanas/core/utils';
import { MenuOption } from '../../../../components/menu-option/menu-option.component';
import { EditProductModal } from '../edit-product-modal/edit-product-modal.component';
import { style } from './product-item.module.css';

interface Props {
  businessProduct: BusinessProduct;
}

export function ProductItem(props: Props) {

  const { businessProduct } = props;

  const menuIconRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  return (
    <Fragment>
      <TableRow style={style.tableRow}>
        <CellImage src={businessProduct.product.image}/>
        <Cell weight='medium' text={businessProduct.product.name}/>
        <Cell weight='medium' color='darkgray' text={businessProduct.product.type}/>
        <Cell 
          weight='bold' 
          color='green' 
          text={
            businessProduct.product.profitType === 'fixed'
              ? formatCurrency(businessProduct.profit)
              : businessProduct.profit + '%'
          }/>
        <CellIcon refIcon={menuIconRef} onClick={() => setOpenMenu(true)}/>
      </TableRow>
      <Menu 
        open={openMenu} 
        anchor={menuIconRef}
        onClose={() => setOpenMenu(false)}>
        <MenuOption 
          text='Editar' 
          onClick={() => setOpenEditModal(true)}/>
      </Menu>
      <EditProductModal
        open={openEditModal}
        businessProduct={businessProduct}
        onClose={() => setOpenEditModal(false)}/>
    </Fragment>
  );
}
